import api from './api';

// API client for the "Cash Market" feature (NSE equity intraday, Buy→Sell / Sell→Buy).
// Multiple named configs per direction — same id-based CRUD shape as spreadApi.ts, replacing
// the earlier single-row-per-direction design.

export type CashMarketDirection = 'BUY_SELL' | 'SELL_BUY';
export type CashMarketBracket = 'P1' | 'P2' | 'P3';

export interface CashMarketConfig {
  id: number;
  name: string;
  direction: CashMarketDirection;
  is_active: boolean;
  entry_active: boolean;
  exit_active: boolean;
  entry_x: number;
  entry_y: number;
  slippage_percentage: number;
  delay_seconds: number;
  invest_amount_k: number;
  no_trade_open_pct: number;
  no_trade_ol_pct: number;
  no_trade_pc_pct: number;
  no_trade_int_pct: number;
  no_trade_open_enabled: boolean;
  no_trade_ol_enabled: boolean;
  no_trade_pc_enabled: boolean;
  no_trade_int_enabled: boolean;
  sl_percentage: number;
  target_percentage: number;
  tsl_percentage: number;
  roi_exit_percentage: number;
  no_of_stocks: number;
  lots: number;
  p1_lots: number;
  p2_lots: number;
  p3_lots: number;
  created_at?: string;
  broker?: string; // 'DHAN' (default) | 'GROWW' | ... — see Broker Management
}

export const cashMarketAPI = {
  getConfigs: () => api.get<CashMarketConfig[]>('/cash-market/config'),
  createConfig: (config: Partial<CashMarketConfig>) => api.post('/cash-market/config', config),
  updateConfig: (id: number, config: Partial<CashMarketConfig>) => api.put(`/cash-market/config/${id}`, config),
  deleteConfig: (id: number) => api.delete(`/cash-market/config/${id}`),
  duplicateConfig: (id: number) => api.post(`/cash-market/config/${id}/duplicate`),
  toggleActive: (id: number, isActive: boolean) => api.put(`/cash-market/config/${id}`, { is_active: isActive }),
  placeOrder: (id: number) => api.post(`/cash-market/config/${id}/place`),
  exitPosition: (orderId: number) => api.post(`/cash-market/order/${orderId}/exit`),
  exitAll: (id: number) => api.post(`/cash-market/config/${id}/exit-all`),
  exitBracket: (id: number, bracket: CashMarketBracket) => api.post(`/cash-market/config/${id}/exit-bracket/${bracket}`),
  exitLossMaking: (id: number) => api.post(`/cash-market/config/${id}/exit-loss`),
  getOpenPositions: (id: number) => api.get(`/cash-market/config/${id}/positions/open`),
  getOrderHistory: (id: number, page = 1, limit = 50) => api.get(`/cash-market/config/${id}/orders?page=${page}&limit=${limit}`),
};
